import useSWR from 'swr';
import axiosInstance from '@/lib/axios';
import type { AvenueMemberSummary, CommunityAvenue } from '@/types';

const fetcher = (url: string) => axiosInstance.get(url).then((res) => res.data);

export function useCommunityAvenues(communityId: string | undefined) {
  const { data, error, isLoading, mutate } = useSWR<{ avenues: CommunityAvenue[] }>(
    communityId ? `/api/communities/${communityId}/avenues` : null,
    fetcher
  );

  return {
    avenues: data?.avenues ?? [],
    isLoading,
    isError: error,
    mutate,
  };
}

export function useMyCommunityAvenues(communityId: string | undefined) {
  const { data, error, isLoading, mutate } = useSWR<{
    avenues: Pick<CommunityAvenue, 'id' | 'name' | 'sortOrder'>[];
  }>(communityId ? `/api/communities/${communityId}/avenues/my` : null, fetcher);

  return {
    avenues: data?.avenues ?? [],
    isLoading,
    isError: error,
    mutate,
  };
}

export function useAvenueAssignments(communityId: string | undefined) {
  const { data, error, isLoading, mutate } = useSWR<{
    membersByAvenue: Record<string, AvenueMemberSummary[]>;
  }>(communityId ? `/api/communities/${communityId}/avenues/assignments` : null, fetcher);

  return {
    membersByAvenue: data?.membersByAvenue ?? {},
    isLoading,
    isError: error,
    mutate,
  };
}
